export const portfolioData = [
  {
    number: "01. ",
    title: "Weather App",
    category: "JavaScript",
    link: "/weather_js",
  },
  {
    number: "02. ",
    title: "Etch-A-Sketch",
    category: "JavaScript",
    link: "/sketch_js",
  },
  {
    number: "03. ",
    title: "Rock Paper Scissors",
    category: "JavaScript",
    link: "/rps_js",
  },
  {
    number: "04. ",
    title: "Calculator",
    category: "JavaScript",
    link: "/calculator_js",
  },
  {
    number: "05. ",
    title: "Weather App",
    category: "React",
    link: "/weather_react",
  },
  {
    number: "06. ",
    title: "Dictionary App",
    category: "React",
    link: "/dictionary_react",
  },
  {
    number: "07. ",
    title: "Book App",
    category: "React",
    link: "/book_react",
  },
  {
    number: "08. ",
    title: "Quotes Generator App",
    category: "React",
    link: "/quotes_generator_react",
  },
  {
    number: "09. ",
    title: "Login & Registration Page",
    category: "React",
    link: "/login_registration_page_react",
  },
  {
    number: "10. ",
    title: "To-do List",
    category: "React",
    link: "/to_do_list_react",
  },
  {
    number: "11. ",
    title: "Expense Tracker",
    category: "React",
    link: "/expense_tracker_react",
  },
  {
    number: "12. ",
    title: "Image Gallery",
    category: "React",
    link: "/image_gallery_react",
  },
  {
    number: "13. ",
    title: "Quiz App",
    category: "React",
    link: "/quiz_app_react",
  },
];
